import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

export const Container = styled.div`
  h3 {
    color: #000;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 500;
  }
  p {
    color: #878787;
    font-family: 'Roboto';
    font-size: 12px;
    font-weight: 400;
  }
  .bg {
    border-radius: 8px;
    background: #fff;
  }

  .value {
    color: #000;

    text-align: right;
    font-family: 'Roboto';
    font-size: 18px;
    font-weight: 700;
    span {
      font-size: 12px;
      font-weight: 400;
    }
  }

  .bd-bottom {
    border-bottom: 0.5px solid #e1e1e1 !important;
  }

  label span {
    color: #292623;
    font-size: 12px;
  }

  .bd-input {
    border: 1px solid #e1e1e1;
    height: 37px;
    border-radius: 4px;

    input {
      width: 100%;
      flex: 1;
      background: transparent;
      border: 0;
      color: #8c8c8c;
      transition-duration: 0.2s;
      padding: 0;

      ::placeholder {
        color: #8c8c8c;
      }
    }
  }

  .btn-login {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .flex-auto {
    flex: auto;
  }
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .title {
    color: #000;
    font-family: 'Roboto';
  }

  h4 {
    color: #000;
    font-family: 'Roboto';
  }

  .tooltip-tax:after {
    background-color: #8c8c8c;
    color: #fff;
    border: 1px solid #8c8c8c;
    border-radius: 15px;
    box-sizing: border-box;
    content: attr(data-tooltip);
    display: none;
    padding: 15px;
    font-size: 12px;
    position: absolute;
    right: 25px;
    bottom: 152px;
    width: calc(100% - 50px);
    z-index: 10000;
    text-align: justify;
  }

  .tooltip-tax:hover:after {
    display: block;
  }

  .btn-filter {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }

  .border-ticket {
    border-radius: 8px;
    border: 1px solid #e1e1e1;

    background: #fff;
  }

  .btn-login {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .values p {
    color: #8c8c8c;
    font-size: 14px;
    font-weight: 400;
  }

  .dot {
    border-bottom: 2px dotted #8c8c8c;
    flex: 1;
    height: 15px;
    margin: 0 8px;
  }

  .color-desc {
    color: #00b15c;
  }

  .total {
    color: #292623 !important;
    text-align: right;
    font-size: 20px !important;
    font-weight: 400;
    span {
      color: #ff7a00;
      font-weight: 700;
    }
  }
`;
